const DEFAULT = 'https://docs.zenprotocol.com/apps/fixed-payout/fixed-payout-generator';

const DOCS = {
  DEFAULT,
};

export default DOCS;
